export const deleteAfterLastSpace = (str) => {
    return str.substring(0, str.lastIndexOf(' '));
}

export const isVowel = (char) => {
    return ("aeiouAEIOU".indexOf(char) != -1);
}

export const startsWithVowel = (string) => {
    if (string && string.length > 0) {
        return isVowel(Array.from(string)[0]);
    }
    return false;
}

export const ucfirst = (string) => {
    if (!string || !(typeof string === 'string')) {
        return string;
    }

    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const lcfirst = (string) => {
    if (!string || !(typeof string === 'string')) {
        return string;
    }

    return string.charAt(0).toLowerCase() + string.slice(1);
}

/**
 * @author ChatGPT4
 * @param string
 * @returns {string}
 */
export const toSlug = (string) => {
    const slug = string
        .toLowerCase()
        .trim()
        .normalize('NFD') // Normalize the string with the Unicode Normalization Form D (NFD)
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (accents)
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
        .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens

    return slug || '';
}

export const fromSlug = (slug, capitalize = false) => {
    // Remove numerals from the beginning of the slug
    let cleanSlug = slug.replace(/^[0-9]+/, '');

    // Remove any leading hyphens that might be left after removing numerals
    cleanSlug = cleanSlug.replace(/^-+/, '');

    let string = cleanSlug
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    if (capitalize) {
        string = ucfirst(string);
    }
    return string;
}

export const snakeToCamel = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        // If obj is an array, recursively apply the conversion to its elements
        return obj.map(snakeToCamel);
    }

    const camelCaseObj = {}; // Create a new object to store the camelCase properties

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const camelKey = key.replace(/_([a-z])/g, (_, match) => match.toUpperCase());
            camelCaseObj[camelKey] = snakeToCamel(obj[key]); // Recursively convert nested objects
        }
    }

    return camelCaseObj;
}
